import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useGetConversationTypes } from "../../../../store/Apis/ConversationTypeApi";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { FilterItem } from "../../../../Helper";
import { SelectedPersona } from "../../../../Interfaces";
import "./Filter.css";
import {  getConversationTypes, useGetConversationHistory } from "../../../../store/Apis/ConversationApi";
import ConversationFilterIcon from "../../../../Custom-imeges/ConversationFilterIcon";
import { ArrowRightIcon } from "../../../../Custom-imeges/ArrowRightIcon";
import { ArrowLeftIcon } from "../../../../Custom-imeges/ArrowLeftIcon";
import { TrueMarkIcon } from "../../../../Custom-imeges/TrueMarkIcon";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import ArrowUpIcon from "../../../../Custom-imeges/ArrowUpIcon";
import { conversationsActions } from "../../../../store/one-query/conversationSlice";
import { Box, Typography } from "@mui/material";

interface FilterProps {
  currentPlace?: string;
  search?: string;
  setFilterPersona?: (value: string[]) => void;
}

const Filter = ({ currentPlace,search,setFilterPersona }: FilterProps) => {
  const conversationTypes = useAppSelector((s) => s.ConversationTypes);
  let darkMode = useAppSelector((state) => state.User.darkMode);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const getConversationTypesMutate = useGetConversationTypes();
  const ConversationTypesUsed = useAppSelector((state) => state.Conversations?.conversations);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const currentSelectedPersonaFilter = useAppSelector(
    (s) => s.ChatsState.currentSelectedPersonaFilter
  );

  const [showFilterByPersona , setShowFilterByPersona] = useState(false);
  const [personaFiltrationInternal,setpersonaFiltrationInternal] = useState<any>([]);
  const [personaFiltrationGlobal,setPersonaFiltrationGlobal]= useState<any>([]);
  const [currentSelectedPersona, setCurrentSelectedPersona] = useState<SelectedPersona>({
    id: null, 
    title: "Persona",
    index: null,
    filterFrom: null,
    filterTo: null,
  })
  
  // const {id , title , index , filterFrom , filterTo} = currentSelectedPersona;
  const FromInputRef = useRef<HTMLInputElement>(null)
  const ToInputRef = useRef<HTMLInputElement>(null)
  const [personaCounter,setPersonaCounter]=useState<number>(0)
  const [isFilter,setIsFilter]=useState<boolean>(false)
  const filterArr: FilterItem[] = [
    {
      title: "All sources",
      value: "all",
    },
    {
      title: "Admission",
      value: "admission",
    },
    {
      title: "Academic",
      value: "academic",
    },
    {
      title: "Research",
      value: "research",
    },
    {
      title: "Student life",
      value: "student_life",
    },
  ];

  useEffect(() => {
    getConversationTypesMutate();
  }, []);

  useEffect(() => {
    setShowFilterByPersona(false)
    if(!dropdownOpen){
      if(personaFiltrationInternal!==personaFiltrationGlobal){
        setFilterPersona&&setFilterPersona(personaFiltrationGlobal)
        setPersonaCounter(personaFiltrationGlobal.length)
      }
    }
  }, [dropdownOpen]);

  const handleShowFilterByPersona = ()=> {
    setShowFilterByPersona(!showFilterByPersona)
  }

  const handleItemClick = (index: number, id: string | null , title:string | null) => {
    setCurrentSelectedPersona({id:id , title: title , index:index });
     setpersonaFiltrationInternal((prev:any) =>{
      if(prev?.includes(id) )
         {
          if(personaCounter===0)
          setPersonaCounter(0)
        else
          setPersonaCounter((prev)=>prev-1)
          return prev?.filter((item:any) => item !== id)
        }
        else{
          setPersonaCounter((prev)=>prev+1)
          return [...prev, id]
        } 
     }

    );
  };
  
  const handleSelectOptionAll = () => {
    setCurrentSelectedPersona({id: null , title: "Persona" , index:null , filterFrom: null , filterTo: null})
    handleShowFilterByPersona();
    setpersonaFiltrationInternal([]);
  };
  
  const handleFilterByEndDate = (endDate:string | null) => {
    setCurrentSelectedPersona((prevPersona) => ({...prevPersona, filterTo: endDate,}));
  }
  
  const handleFilterByStartDate = (startDate:string | null) => {
    setCurrentSelectedPersona((prevPersona) => ({...prevPersona, filterFrom: startDate,}));
  }
  
  const handleApplyFiltration = ()=> {
    if(currentSelectedPersona?.filterFrom || currentSelectedPersona?.filterTo || currentSelectedPersona?.title !== "Persona"){
      toggleDropdown();
      setFilterPersona?.(personaFiltrationInternal);
    }
    setIsFilter(true)
    setPersonaFiltrationGlobal(personaFiltrationInternal)
  }

  const handleCancelFiltration = () => {
    toggleDropdown()
    setCurrentSelectedPersona({id: null , title: "Persona" , index:null , filterFrom: null , filterTo: null})
  }
  const uniqueConversations = new Map();
  ConversationTypesUsed?.forEach(item => {
      if (!uniqueConversations?.has(item?.persona?.id)) {
          uniqueConversations?.set(item?.persona?.id, item?.persona);
      }
  });

  const filteredConversations = Array.from(uniqueConversations?.values())?.sort((a, b) => a?.order - b?.order);

  const handleShowFilteredPersona = () => {
    const [firstPersona, secondPersona] = personaFiltrationInternal?.slice(0, 2)
    ?.map((id:string) => conversationTypes?.data?.find((item) => item?.id === id));

    // Construct the string format
    return `${firstPersona?.title || ''}${secondPersona ? ', ' + secondPersona?.title?.slice(0, 2) : ''}`;
  };

  const HandleDataClick = (e: any) => {
    e?.current?.showPicker();
  }

  const handleSelectAll=()=>{
    if(filteredConversations?.length === 0) return;
    setPersonaCounter(filteredConversations?.length)
    const selectedIds = filteredConversations?.map(convo => convo?.id); 
    setpersonaFiltrationInternal(selectedIds);
  }

  const handleResetSelectionPersona=()=>{
    if(personaFiltrationInternal?.length === 0) return;
    setPersonaCounter(0)
    setpersonaFiltrationInternal([]);
  }

  const handleResetAll = ()=>{
    setPersonaFiltrationGlobal([]);
    setFilterPersona?.([]);
    setpersonaFiltrationInternal([]);
    setPersonaCounter(0)
    setIsFilter(false)
    setDropdownOpen(false);
  }

  useEffect(() => {
    if (window.location.pathname.includes("suites") || window.location.pathname.includes("workflow")) {
      handleResetAll();
      setDropdownOpen(false);
    }
  }, [window.location.pathname]);
  // to pass filter persona that work with search because exist two places call end point 
  useEffect(() => {
    setFilterPersona&&setFilterPersona(personaFiltrationGlobal);
  }, [personaFiltrationGlobal]);
  return (
    <div className="Filter-style">
      <Dropdown
        show={dropdownOpen}
        onToggle={toggleDropdown}
        autoClose="outside"
      >
        <Dropdown.Toggle className="bg-transparent border-0">
          {currentPlace === "Sidebar" ?(
             <ConversationFilterIcon/>
          ): (
            <img
              className="help-filter-icon"
              src={"/images/GetConversations/filter_alt.svg"}
            />
          )}
        </Dropdown.Toggle>
         <Dropdown.Menu
          className={`${dropdownOpen ? "filter-menu show" : "filter-menu"}`}
         
        >
          <Dropdown.Header
            className="d-flex align-items-center justify-content-between"
            >
            <div className="d-flex flex-column">
            <span>Persona {personaCounter>0&&<span className="ms-2 personaCounter">{personaCounter}</span>}</span>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography 
              sx={{
              opacity:filteredConversations?.length>0?1:0.7,
              userSelect:"none",
              cursor: filteredConversations?.length>0 ? "pointer" : "not-allowed",
              }}>
              <span className="font-blue" onClick={handleSelectAll}>Select all</span>
              </Typography>
              <Typography 
              sx={{
              opacity:personaFiltrationInternal?.length>0?1:0.7,
              userSelect:"none",
              cursor: personaFiltrationInternal?.length ? "pointer" : "not-allowed",
              }}>
              <span className="font-blue ms-3" onClick={handleResetSelectionPersona}>Deselect</span>
              </Typography>
            </Box>
            </div>
            <img className="Close-menu-personas" onClick={toggleDropdown}/>
          </Dropdown.Header>
          {currentPlace === "Sidebar" ? (
            <div className="filters">
                <div className="personas">
                  <div className="categories overflow-x-hidden overflow-y-auto">

                    {filteredConversations &&filteredConversations.length>0?
                      filteredConversations?.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          className={`d-flex align-items-center gap-1 ${
                            personaFiltrationInternal?.includes(item?.id) ? "selected" : ""
                          }`}
                          onClick={() =>
                            handleItemClick(index, item?.id, item.title)
                          }
                        >
                          <div className={`persona-checkbox ${personaFiltrationInternal?.includes(item?.id) && 'checked'}`}>
                            {personaFiltrationInternal?.includes(item?.id) && <TrueMarkIcon/>}
                          </div>
                          <p className="personaFilterItem mb-0">
                            {item?.title}
                          </p>

                        </Dropdown.Item>
                      )):(
                        <div className="no-personas">
                          <p className="font-blue no-personas-text">No personas found</p>
                        </div>
                      )}
                  </div>
                </div>
            <div className="filter-buttons d-flex flex-column">
            <button className={`apply-btn ${personaCounter===0?"disable-btn":"not-disable"}`} disabled={personaCounter===0} onClick={handleApplyFiltration}>Apply</button>
            <span className="font-blue mt-2"style={{  textDecoration: "underline"}} onClick={handleResetAll}>Reset all</span>
            </div>
            </div>

          ) : (
            <div className="categories overflow-x-hidden overflow-y-auto">
              {filterArr &&
                filterArr.map((item, index) => (
                  <Dropdown.Item
                  key={index}
                  className={`${
                    index === currentSelectedPersona?.index && currentSelectedPersonaFilter
                        ? "selected"
                        : ""
                    }`}
                  >
                    <p className="personaFilterItem mb-0">
                      {item?.title}
                    </p>
                  </Dropdown.Item>
                ))}
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
      {isFilter&&<span className="circle-red"></span>}
    </div>
  );
};

export default Filter;